import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { throwIfEmpty } from 'rxjs/operators';
import { ApiService } from 'src/app/services/api.service';
import { UtilityService } from 'src/app/services/utility.service';
import { messages } from '../../../../../common/messages'
import { environment } from 'src/environments/environment';
import { debounce } from 'lodash'
import icVisibility from '@iconify/icons-ic/twotone-visibility';
import icVisibilityOff from '@iconify/icons-ic/twotone-visibility-off';

@Component({
    selector: 'app-reset-password',
    templateUrl: './reset-password.component.html',
    styleUrls: ['./reset-password.component.scss'],
    standalone: false
})
export class ResetPasswordComponent implements OnInit {

    //view child
    @ViewChild('lowerCase') private lowerCase: any;
    @ViewChild('upperCase') private upperCase: any;
    @ViewChild('oneNumeric') private oneNumeric: any;
    @ViewChild('minLength') private minLength: any;
    @ViewChild('symbol') private symbol: any;

  passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[-+_!@#$%^&*., ?])[A-Za-z\d-+_!@#$%^&*., ?]{8,16}$/
  lowerCaseRegex = /.*[a-z].*/
  upperCaseRegex = /.*[A-Z].*/
  oneNumericRegex = /.*\d.*/
  oneSymbol = /(?=.*[-+_!@#$%^&*., ?]).+/
  public form: any;
  message: any;
  token: any;
  userType: any;
  assets = environment.assets;
  displayUserType: string = '';
  hide = true;
  chide = true;  
  hide1 = true;
  hide2 = true;
  icVisibility = icVisibility;
  icVisibilityOff = icVisibilityOff;
  constructor(
    private fb: FormBuilder,
    private route: ActivatedRoute,
    private utility: UtilityService,
    private api: ApiService,
    private router: Router
  ) {
    this.route.params
      .subscribe(
        (params: any) => {
          this.token = params['token'];
          this.userType = params['userType'];
        }
      );

  }

  ngOnInit(): void {

    switch (this.userType) {
      case 'pcv':
        this.displayUserType = "Veterinarian"
        break;
      case 'specialist':
        this.displayUserType = "Specialist"
        break;
      case 'admin':
        this.displayUserType = "Admin"
        break;
      default:
        break;
    }
    this.validateResetPasswordLink();
    this.message = messages
    this.setupResetPasswordForm();

  }

  //Method to setup password form
  setupResetPasswordForm() {
    this.form = this.fb.group({
      password: [null,
        Validators.compose([
          Validators.required,
          Validators.pattern(this.passwordRegex),
          this.noWhitespaceValidator])],
      confirmPassword: [""]
    }, {
      validator: this.comparePassword
    });
  }

  // Method to check if field contains empty space
  noWhitespaceValidator(control: any) {
    const isWhitespace = (control.value || '').match(/\s/g)
    const isValid = !isWhitespace;
    return isValid ? null : { 'whitespace': true };
  }

  //Method to ensure confirm password field has correct values
  comparePassword(control: any) {

    let password = control.get("password").value;
    let confirmPassword = control.get("confirmPassword").value;
    control.get("confirmPassword").setErrors({ invalid: true });

    if (confirmPassword.length != '') {
      if (password !== confirmPassword) {
        control.get("confirmPassword").setErrors({ passwordCompare: true });
      }
      else {
        control.get("confirmPassword").setErrors(null);
      }
    }
    else {
      control.get("confirmPassword").setErrors({ invalid: true });
    }
  }

  //Method called to reset the password
  resetPasword() {
    if (this.form.controls.password.status === 'VALID' && this.form.controls.confirmPassword.status === 'VALID') {
      this.utility.setSpinner(true)

      let passwordDetails = {
        token: this.token,
        password: this.form.value.password
      }
      this.api.apiRequest("post", "user/resetPassword", passwordDetails)
        .subscribe((res) => {
          this.utility.setSpinner(false)
          this.utility.openSnackBar("New Password set successfully. Please login to continue", "Ok")
          switch (this.userType) {
            case 'pcv':
              this.router.navigate(['auth/pcv-signin']);
              break;
            case 'specialist':
              this.router.navigate(['auth/specialist-signin']);
              break;
            case 'admin':
              this.router.navigate(['auth/admin-signin']);
              break;
            default:
              break;
          }

        }, (err) => {
          this.utility.setSpinner(false)
          if (err.status == "invalidToken") {
            this.router.navigateByUrl('auth/forgot-password');
            let msg = 'Password reset link appears to be invalid. Please request a new link.'
              /**
           * ADD condition to navigate to pages based on user type
           */
         
            this.utility.openSnackBar(msg, 'Ok')
            
         
          } else {
            this.utility.openSnackBar("something went wrong.", "Ok");
          }

          switch (this.userType) {
            case 'pcv':
              this.router.navigate(['auth/pcv-signin']);
              break;
            case 'specialist':
              this.router.navigate(['auth/specialist-signin']);
              break;
            case 'admin':
              this.router.navigate(['auth/admin-signin']);
              break;
            default:
              break;
          }
        })

    }
  }

  //method to check and uncheck given password conditions
  checkPassword = debounce(() => {

    let password = this.form.controls.password.value

    if (this.oneNumericRegex.test(password)) {
      this.oneNumeric.checked = true
    } else {
      this.oneNumeric.checked = false

    }

    if (password.length >= 8) {
      this.minLength.checked = true;
    } else {
      this.minLength.checked = false;
    }

    if (this.lowerCaseRegex.test(password)) {
      this.lowerCase.checked = true
    } else {
      this.lowerCase.checked = false
    }

      if (this.upperCaseRegex.test(password)) {
        this.upperCase.checked = true
      } else {
        this.upperCase.checked = false

      }

      if (this.oneSymbol.test(password)) {
        this.symbol.checked = true
      } else {
        this.symbol.checked = false
  
      }
    
  }, 350)
  // Method used to check the validity of reset password link on ngoninit
  validateResetPasswordLink() {
    let data = {
      token: this.token
    }
    this.api.apiRequest("post", "user/validateLink", data).subscribe(res => {
      if (!res) {
        switch (this.userType) {
          case 'pcv':
            this.router.navigate(['auth/pcv-forgot-password']);
            break;
          case 'specialist':
            this.router.navigate(['auth/specialist-forgot-password']);
            break;
          case 'admin':
            this.router.navigate(['auth/admin-forgot-password']);
            break;
          default:
            break;
        }
        let msg = 'Password reset link appears to be invalid. Please request a new link.'
        this.utility.openSnackBar(msg, 'Ok')
      }
    })
  }
}
